document.addEventListener('DOMContentLoaded', function() {
    const checkExist = setInterval(function() {
        if (window.tlCartGoalEmbed) {
            clearInterval(checkExist);
            const originalToggleGifts = window.tlCartGoalEmbed.toggleGifts;
            
            window.tlCartGoalEmbed.toggleGifts = function(cartGoalIndex, giftMilestoneIndex, isOpen = true) {
                originalToggleGifts.call(this, cartGoalIndex, giftMilestoneIndex, isOpen);
                
                if (isOpen) {
                    const selector = `.tl__cart-goal__gift-modal-${cartGoalIndex}-${giftMilestoneIndex}`;
                    const productInfos = document.querySelectorAll(`${selector} .tl__cart-goal__product-image-info`);
                    
                    let giftsData = [];
                    try {
                        const rulesObj = window.tlCartGoalRules;
                        if (rulesObj) {
                            Object.values(rulesObj).forEach(rule => {
                                if (rule && rule.milestones) {
                                    const milestones = typeof rule.milestones === 'string' ? JSON.parse(rule.milestones) : rule.milestones;
                                    if (milestones[giftMilestoneIndex] && milestones[giftMilestoneIndex].gifts) {
                                        let parsedGifts = typeof milestones[giftMilestoneIndex].gifts === 'string' 
                                            ? JSON.parse(milestones[giftMilestoneIndex].gifts) 
                                            : milestones[giftMilestoneIndex].gifts;
                                        giftsData = giftsData.concat(parsedGifts);
                                    }
                                }
                            });
                        }
                    } catch (e) { console.log(e); }
                    
                    const giftIndexInGiftsList = window.tlCartGoalEmbed.milestoneIndexInGiftsList?.get(giftMilestoneIndex);
                    const giftVariants = giftIndexInGiftsList !== undefined ? 
                        (window.tlCartGoalEmbed.gifts[giftIndexInGiftsList] || []) : [];
                    
                    productInfos.forEach((infoBlock, idx) => {
                        const variant = giftVariants[idx];
                        if (!variant) return;
                        infoBlock.style.overflow = "hidden";
                        
                        if (!infoBlock.querySelector('.my-custom-span')) {
                            const newSpan = document.createElement('span');
                            newSpan.className = 'my-custom-span';
                            
                            newSpan.style.cssText = `
                                font-size: 13px; 
                                color: #666; 
                                display: none; 
                                margin-top: 4px; 
                                font-weight: normal; 
                                font-family: sans-serif; 
                                display: -webkit-box; 
                                -webkit-line-clamp: 1; 
                                -webkit-box-orient: vertical; 
                                overflow: hidden; 
                                text-overflow: ellipsis; 
                                word-break: break-all;
                            `;
                            
                            const titleElement = infoBlock.querySelector('p');
                            if (titleElement) {
                                titleElement.style.webkitLineClamp = 'unset';
                                titleElement.style.display = 'block';
                                
                                if (!titleElement.querySelector('.tl-title-wrapper')) {
                                    const titleWrapper = document.createElement('span');
                                    titleWrapper.className = 'tl-title-wrapper';
                                    titleWrapper.style.cssText = 'display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;';
                                    
                                    while (titleElement.firstChild) {
                                        titleWrapper.appendChild(titleElement.firstChild);
                                    }
                                    titleElement.appendChild(titleWrapper);
                                }
                                titleElement.appendChild(newSpan);
                            }

                            let handle = null;
                            if (giftsData.length > 0) {
                                const matchedGift = giftsData.find(g => g.id.includes(String(variant.id)));
                                if (matchedGift) { handle = matchedGift.handle; }
                            }
                            
                            if (handle) {
                                fetch('/products/' + handle + '.js')
                                    .then(res => res.json())
                                    .then(productData => {
                                        let tempDiv = document.createElement('div');
                                        tempDiv.innerHTML = productData.description || '';
                                        let textDesc = tempDiv.textContent || tempDiv.innerText || '';
                                        
                                        if (textDesc.trim() !== '') {
                                            newSpan.textContent = textDesc.trim();
                                            newSpan.style.display = '-webkit-box'; 
                                        }
                                    })
                                    .catch(err => console.log(err));
                            }
                        }
                    });
                }
            };
        }
    }, 100);
});
